// Homepage FAQ rich-result data (only injected on the homepage).
export const homeFaqSchema = [
  {
    "q": "How does online prayer delivery to Jerusalem work?",
    "a": "You submit your prayer online. We print it on a physical scroll each week and personally hand-carry it to the Jerusalem holy site(s) you choose — the Western Wall, Church of the Holy Sepulchre, Garden Tomb, Mount of Olives, Via Dolorosa, Garden of Gethsemane or Mount Zion. After delivery we email you a dated photograph of your scroll at the site as proof of delivery."
  },
  {
    "q": "Will I receive photo proof that my prayer was actually delivered?",
    "a": "Yes. Every paid delivery includes a dated photograph of your printed prayer scroll at the holy site, emailed directly to you after delivery. Our $150 Emergency Rush tier also includes a short 15–30 second video clip."
  },
  {
    "q": "How quickly is my prayer delivered to Jerusalem?",
    "a": "Standard orders are carried on the weekly Sunday scroll and the delivery photo is emailed on Monday. For urgent requests we offer a $150 Emergency Rush service with next-business-day hand delivery (Sun–Thu in Jerusalem)."
  },
  {
    "q": "Can I pray for someone else, or dedicate the prayer?",
    "a": "Yes. Every prayer form includes a 'Dedicated to' field so you can send a prayer for a family member, friend, or loved one. Your written prayer and the dedication are placed together on the scroll."
  },
  {
    "q": "Which holy sites can my prayer be delivered to?",
    "a": "We deliver to seven Jerusalem holy sites: the Western Wall, Church of the Holy Sepulchre, Garden Tomb, Mount of Olives, Via Dolorosa, Garden of Gethsemane, and Mount Zion."
  },
  {
    "q": "Is Jerusalem Holy Prayer a religious or spiritual service?",
    "a": "Jerusalem Holy Prayer is a physical prayer delivery service — not a religious institution. We make no spiritual claims. We print your prayer on a scroll, carry it to the holy site you select, and send you a dated photograph as proof of physical delivery. All faiths and traditions are welcome."
  },
  {
    "q": "What is your refund policy?",
    "a": "We offer a 30-day money-back guarantee. If we fail to deliver your prayer to the chosen holy site, or you are unsatisfied with the dated photograph you receive, email us at info@jerusalemholyprayer.org and we will issue a full refund."
  },
  {
    "q": "Is my prayer kept private?",
    "a": "Yes. Your written prayer is private by default. We only display prayers publicly if you explicitly opt in to the public prayer wall. All personal data is handled according to our Privacy Policy."
  }
];
